import * as service from './service'
export default {
  namespace: 'rewardCenterList',
  state: {
    activityList: []
  },
  effects: {
    * getActivityList ({ payload }, { call, put }) {
      const res = yield call(service.getActivityList, payload)
      yield put({
        type: 'save',
        payload: {
          activityList: res.data
        }
      })
      return res
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
